import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

export function StyledDisableButton({ disabled, onClick, style, ...props }) {
  const disabledStyle = {
    ...style,
    borderColor: "rgba(34, 36, 38, 0.5)",
    cursor: "default",
    opacity: "0.45",
    boxShadow: "none",
  };

  const setOnClick = () => {
    if (disabled) {
      return (e) => {
        e.stopPropagation();
      };
    }

    return onClick;
  };

  return (
    <Button
      {...props}
      style={disabled ? disabledStyle : style}
      onClick={setOnClick()}
      disabled={false}
    />
  );
}

StyledDisableButton.propTypes = {
  disabled: PropTypes.bool,
  style: PropTypes.object,
  onClick: PropTypes.func.isRequired,
};

StyledDisableButton.defaultProps = {
  disabled: false,
  style: {},
};

export default StyledDisableButton;
